<template>
    <BaseCard padding="md" class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div class="flex items-center gap-3 min-w-0 flex-1">
            <ReflectionIcon v-if="showIcon" :kind="task.is_self_assessment_only ? 'self' : 'sixty'" size="md" />
            <div class="flex flex-col gap-0.5 min-w-0">
                <div class="body-semibold text-valence-stone-900">Complete your {{ task.title }}</div>
                <div v-if="task.subtitle" class="scaffold-body-small text-valence-stone-500">{{ task.subtitle }}</div>
                <div v-if="closes" class="scaffold-details-small text-valence-stone-500">{{ closes }}</div>
            </div>
        </div>
        <a :href="href" class="base-btn-neutral base-btn-square base-btn-sm sm:shrink-0 whitespace-nowrap text-center self-start sm:self-auto" @click.prevent="emit('start', task)">
            Start
        </a>
    </BaseCard>
</template>

<script setup lang="ts">
import type { PendingPersonalTask } from "~vue/api/generated/reflections";
import BaseCard from "~vue/components/BaseCard.vue";
import ReflectionIcon from "~vue/pages/reflections/ReflectionIcon.vue";
import { closesLabel } from "~vue/utils/threeSixty";
import { computed } from "vue";

interface Props {
    task: PendingPersonalTask;
    // The icon disambiguates task kinds when the Upcoming tab mixes 360, self,
    // and team-feedback rows. Inside a single-kind tab (360s / Self Reflection),
    // the section header already provides that context, so the icon is redundant.
    showIcon?: boolean;
}

const { task, showIcon = true } = defineProps<Props>();
const emit = defineEmits<{ (event: "start", task: PendingPersonalTask): void }>();

const closes = computed(() => closesLabel(task.closes_at));

const href = computed(() => {
    if (task.kind === "self_reflection_cycle") {
        return `/reflections/360/${task.id}/self`;
    }
    if (task.kind === "self_reflection_campaign") {
        return `/reflections/360/start?mode=self&campaign_id=${task.id}`;
    }
    if (task.kind === "cycle_setup_campaign") {
        return `/reflections/360/start?campaign_id=${task.id}`;
    }
    return `/reflections/360/${task.id}/nominate`;
});
</script>
